import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'react-recompose'

import PlusMinusControl from './PlusMinusControl'
import './room-field.scss'

const RoomField = ({
  name,
  value,
  label,
  description,
  onChange,
  minValue,
  maxValue,
}) => (
  <div className="room-field">
    <div className="room-field-panel__left">
      <div className="room-field__label">
        {label}
      </div>
      {
        description && (
        <div className="room-field__description">
          {description}
        </div>
        )
      }
    </div>
    <PlusMinusControl
      className="room-field-panel__right"
      name={name}
      onChange={onChange}
      value={value}
      minValue={minValue}
      maxValue={maxValue}
      initialValue={value}
    />
  </div>
)

RoomField.defaultProps = {
  value: 0,
}

RoomField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  minValue: PropTypes.number.isRequired,
  maxValue: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default pure(RoomField)
